import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=159f278f"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"
import style0 from "./Strategy.vue?vue&type=style&index=0&id=159f278f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports